












import { defineComponent } from '@nuxtjs/composition-api';
import { getIsContainer } from '~/modules/storyblok/getters/getIsContainer';

export default defineComponent({
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  setup(_) {
    const { isContainer } = getIsContainer();

    return { isContainer };
  },
});
